export const provinces = [
  '',
  'AG',
  'AL',
  'AN',
  'AO',
  'AP',
  'AQ',
  'AR',
  'AT',
  'AV',
  'BA',
  'BG',
  'BI',
  'BL',
  'BN',
  'BO',
  'BR',
  'BS',
  'BT',
  'BZ',
  'CA',
  'CB',
  'CE',
  'CH',
  'CL',
  'CN',
  'CO',
  'CR',
  'CS',
  'CT',
  'CZ',
  'EN',
  'FC',
  'FE',
  'FG',
  'FI',
  'FM',
  'FR',
  'GE',
  'GO',
  'GR',
  'IM',
  'IS',
  'KR',
  'LC',
  'LE',
  'LI',
  'LO',
  'LT',
  'LU',
  'MB',
  'MC',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NA',
  'NO',
  'NU',
  'OR',
  'PA',
  'PC',
  'PD',
  'PE',
  'PG',
  'PI',
  'PN',
  'PO',
  'PR',
  'PT',
  'PU',
  'PV',
  'PZ',
  'RA',
  'RC',
  'RE',
  'RG',
  'RI',
  'RM',
  'RN',
  'RO',
  'SA',
  'SI',
  'SM',
  'SO',
  'SP',
  'SR',
  'SS',
  'SU',
  'SV',
  'TA',
  'TE',
  'TN',
  'TO',
  'TP',
  'TR',
  'TS',
  'TV',
  'UD',
  'VA',
  'VB',
  'VC',
  'VE',
  'VI',
  'VR',
  'VT',
  'VV',
];

export const regions = [
  ['', ''],
  ['ABR', 'Abruzzo'],
  ['BAS', 'Basilicata'],
  ['CAL', 'Calabria'],
  ['CAM', 'Campania'],
  ['EMI', 'Emilia Romagna'],
  ['FVG', 'Friuli Venezia Giulia'],
  ['LAZ', 'Lazio'],
  ['LIG', 'Liguria'],
  ['LOM', 'Lombardia'],
  ['MAR', 'Marche'],
  ['MOL', 'Molise'],
  ['PIE', 'Piemonte'],
  ['PUG', 'Puglia'],
  ['SAR', 'Sardegna'],
  ['SIC', 'Sicilia'],
  ['TOS', 'Toscana'],
  ['TRE', 'Trentino'],
  ['UMB', 'Umbria'],
  ['AOS', "Valle d'Aosta"],
  ['VEN', 'Veneto'],
];

export const italianRegionsProvinces: {
  [key: string]: {
    name: string;
    provinces: string[];
  };
} = {
  PIE: {
    name: 'Piemonte',
    provinces: ['TO', 'VC', 'BI', 'NO', 'CN', 'AT', 'AL', 'VB'],
  },
  AOS: {
    name: "Valle d'Aosta",
    provinces: ['AO'],
  },
  LOM: {
    name: 'Lombardia',
    provinces: ['MI', 'BG', 'BS', 'CO', 'CR', 'LC', 'LO', 'MN', 'PV', 'SO', 'VA', 'MB'],
  },
  TRE: {
    name: 'Trentino-Alto Adige',
    provinces: ['BZ', 'TN'],
  },
  VEN: {
    name: 'Veneto',
    provinces: ['VE', 'PD', 'RO', 'TV', 'BL', 'VI', 'VR'],
  },
  FVG: {
    name: 'Friuli Venezia Giulia',
    provinces: ['TS', 'GO', 'PN', 'UD'],
  },
  LIG: {
    name: 'Liguria',
    provinces: ['GE', 'IM', 'SP', 'SV'],
  },
  EMI: {
    name: 'Emilia-Romagna',
    provinces: ['BO', 'FE', 'MO', 'PR', 'PC', 'RA', 'RE', 'RN', 'FC'],
  },
  TOS: {
    name: 'Toscana',
    provinces: ['FI', 'AR', 'GR', 'LI', 'LU', 'MS', 'PI', 'PO', 'PT', 'SI'],
  },
  UMB: {
    name: 'Umbria',
    provinces: ['PG', 'TR'],
  },
  MAR: {
    name: 'Marche',
    provinces: ['AN', 'AP', 'FM', 'MC', 'PU'],
  },
  LAZ: {
    name: 'Lazio',
    provinces: ['RM', 'FR', 'LT', 'RI', 'VT'],
  },
  ABR: {
    name: 'Abruzzo',
    provinces: ['AQ', 'CH', 'PE', 'TE'],
  },
  MOL: {
    name: 'Molise',
    provinces: ['CB', 'IS'],
  },
  CAM: {
    name: 'Campania',
    provinces: ['NA', 'AV', 'BN', 'CE', 'SA'],
  },
  PUG: {
    name: 'Puglia',
    provinces: ['BA', 'BT', 'BR', 'FG', 'LE', 'TA'],
  },
  BAS: {
    name: 'Basilicata',
    provinces: ['MT', 'PZ'],
  },
  CAL: {
    name: 'Calabria',
    provinces: ['CZ', 'CS', 'KR', 'RC', 'VV'],
  },
  SIC: {
    name: 'Sicilia',
    provinces: ['AG', 'CL', 'CT', 'EN', 'ME', 'PA', 'RG', 'SR', 'TP'],
  },
  SAR: {
    name: 'Sardegna',
    provinces: ['CA', 'NU', 'OR', 'SS', 'SU'],
  },
};

export const italianProvincesNames: { [key: string]: string } = {
  TO: 'Torino',
  VC: 'Vercelli',
  BI: 'Biella',
  NO: 'Novara',
  CN: 'Cuneo',
  AT: 'Asti',
  AL: 'Alessandria',
  VB: 'Verbano-Cusio-Ossola',
  AO: 'Aosta',
  MI: 'Milano',
  BG: 'Bergamo',
  BS: 'Brescia',
  CO: 'Como',
  CR: 'Cremona',
  LC: 'Lecco',
  LO: 'Lodi',
  MN: 'Mantova',
  PV: 'Pavia',
  SO: 'Sondrio',
  VA: 'Varese',
  MB: 'Monza e della Brianza',
  BZ: 'Bolzano/Bozen',
  TN: 'Trento',
  VE: 'Venezia',
  PD: 'Padova',
  RO: 'Rovigo',
  TV: 'Treviso',
  BL: 'Belluno',
  VI: 'Vicenza',
  VR: 'Verona',
  TS: 'Trieste',
  GO: 'Gorizia',
  PN: 'Pordenone',
  UD: 'Udine',
  GE: 'Genova',
  IM: 'Imperia',
  SP: 'La Spezia',
  SV: 'Savona',
  BO: 'Bologna',
  FE: 'Ferrara',
  MO: 'Modena',
  PR: 'Parma',
  PC: 'Piacenza',
  RA: 'Ravenna',
  RE: 'Reggio Emilia',
  RN: 'Rimini',
  FC: 'Forlì-Cesena',
  FI: 'Firenze',
  AR: 'Arezzo',
  GR: 'Grosseto',
  LI: 'Livorno',
  LU: 'Lucca',
  MS: 'Massa-Carrara',
  PI: 'Pisa',
  PO: 'Prato',
  PT: 'Pistoia',
  SI: 'Siena',
  PG: 'Perugia',
  TR: 'Terni',
  AN: 'Ancona',
  AP: 'Ascoli Piceno',
  FM: 'Fermo',
  MC: 'Macerata',
  PU: 'Pesaro e Urbino',
  RM: 'Roma',
  FR: 'Frosinone',
  LT: 'Latina',
  RI: 'Rieti',
  VT: 'Viterbo',
  AQ: "L'Aquila",
  CH: 'Chieti',
  PE: 'Pescara',
  TE: 'Teramo',
  CB: 'Campobasso',
  IS: 'Isernia',
  NA: 'Napoli',
  AV: 'Avellino',
  BN: 'Benevento',
  CE: 'Caserta',
  SA: 'Salerno',
  BA: 'Bari',
  BT: 'Barletta-Andria-Trani',
  BR: 'Brindisi',
  FG: 'Foggia',
  LE: 'Lecce',
  TA: 'Taranto',
  MT: 'Matera',
  PZ: 'Potenza',
  CZ: 'Catanzaro',
  CS: 'Cosenza',
  KR: 'Crotone',
  RC: 'Reggio Calabria',
  VV: 'Vibo Valentia',
  AG: 'Agrigento',
  CL: 'Caltanissetta',
  CT: 'Catania',
  EN: 'Enna',
  ME: 'Messina',
  PA: 'Palermo',
  RG: 'Ragusa',
  SR: 'Siracusa',
  TP: 'Trapani',
  CA: 'Cagliari',
  NU: 'Nuoro',
  OR: 'Oristano',
  SS: 'Sassari',
  SU: 'Sud Sardegna',
};

export const allProvinces = Object.values(italianRegionsProvinces)
  .flatMap((region) => region.provinces)
  .sort();

export const genders = [
  ['', ''],
  ['male', 'Maschio'],
  ['female', 'Femmina'],
];

export const gendersWithMixed = [
  ['', ''],
  [0, 'Maschile'],
  [1, 'Femminile'],
  [2, 'Misto'],
];

export const competitionTypes = [
  ['', ''],
  ['true', 'Campionati a Squadre'],
  ['false', 'Tornei FITP'],
];

export const competitionStatuses = [
  ['', ''],
  ['completed', 'Concluso'],
  ['running', 'In corso'],
  ['scheduled', 'Programmato'],
];

export const competitionAgeCategories = [
  ['', ''],
  ['open', 'Open'],
  ['under', 'Under'],
  ['over', 'Over'],
];

export const competitionRankings = [
  ['', ''],
  ['open', 'Open'],
  ['seconda', 'Seconda categoria'],
  ['terza', 'Terza categoria'],
  ['quarta', 'Quarta categoria'],
];

export const getRegionCode = (name: string) => {
  const region = regions.find((r) => {
    if (r[1].toUpperCase() === name.toUpperCase()) return true;
    return false;
  });
  return region && region[0];
};

export const getTeacherQualification = (qual: string) => {
  if (qual === 'IS1') return 'Istruttore 1° grado (IS1)';
  if (qual === 'IS2') return 'Istruttore 2° grado (IS2)';
  if (qual === 'MN') return 'Maestro Nazionale (MN)';
  if (qual === 'TN') return 'Tecnico Nazionale (TN)';
  return qual;
};
